import { LoadingOutlined } from '@ant-design/icons'
import ModalConfirm from '@components/AppModal/ModalConfirm'
import PrintEmailContent from '@components/PrintEmailContent'
import router from '@stores/router'
import { getQueryParams } from '@utils/functions'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'

import store from './store'

const InvoiceSummaryPrint = () => {
  const params = getQueryParams(router.location.search, router.location.state)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    document.title = 'Invoice Summary'

    if (params) {
      setLoading(true)
      async function fetchData() {
        try {
          // Handle array query parameters (e.g., multipleSettlementStatus=5&multipleSettlementStatus=2)
          const urlParams = new URLSearchParams(router.location.search)
          const processedParams = { ...params }

          // Convert repeated query parameters to arrays
          const multipleSettlementStatus = urlParams.getAll(
            'multipleSettlementStatus'
          )
          if (multipleSettlementStatus.length > 0) {
            processedParams.multipleSettlementStatus = multipleSettlementStatus
          }

          const fundingTypes = urlParams.getAll('fundingTypes')
          if (fundingTypes.length > 0) {
            processedParams.fundingTypes = fundingTypes
          }

          const data = await store.printInvoiceSummary(processedParams)
          setData(data)
          setLoading(false)

          if (!data) {
            throw new Error('Cannot found')
          }
        } catch (error) {
          setLoading(false)
          setError(error)
        }
      }
      fetchData()
    } else {
      setError(new Error('Missing parameter'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) {
    return (
      <div className="container text-center">
        <LoadingOutlined
          style={{ fontSize: '50px', color: 'var(--blue-400)' }}
        />
      </div>
    )
  }

  if (error) {
    return (
      <div className="container text-lg">
        <h1>Something Error</h1>
        <p>{error.message}</p>
      </div>
    )
  }

  if (!data) {
    return null
  }

  return (
    <div>
      <PrintEmailContent
        html={data}
        title="Invoice Summary"
        autoHeight
        capturePrintShortcut
      />
      {showModal && (
        <ModalConfirm
          modalParams={{
            message: 'Do you want to send funding statement to the recipents?',
            onOk: () => {
              setShowModal(false)
            },
          }}
          onCancel={() => {
            setShowModal(false)
          }}
        />
      )}
    </div>
  )
}

export default observer(InvoiceSummaryPrint)
